import { useState } from 'react'
import refresh from '../assets/refreshIconBlack.svg'
import email from '../assets/email.svg'
import FeedbackIcon from '../assets/feedbackIcon'
import SendIcon from '../assets/sendIcon'
import ChatBubble from '../assets/chatBubble'
import { stopVideosPlaying } from './utils'
import { defaultCapitalisedUserInitial, defaultRelationship, defaultUserInitial, defaultUserName } from '../plugins/utils/ascUtils'
import FeedbackForm from './feedbackForm'
import UpChevronIcon from '../assets/upChevronIcon'
const AvaIcon = require('../assets/AccessAva_Logo.png')

interface Props {
    toggleMenuActive: (params: boolean) => void
    toggleSound: (params: boolean) => void
    soundOn: boolean
    mainSizing: {
        width: string
        height: string
        menuOverlayHeight: string
    }
    restart: () => void
    dataset: any
    send: (msg: string, payload: string, options?: any) => void
    isSending: boolean
    closeMenu: () => void
    animateCloseMenu: boolean
    toggleIsActive: () => void
}

export const Menu: React.FC<Props> = ({
    toggleMenuActive,
    toggleSound,
    soundOn,
    mainSizing,
    restart,
    dataset,
    send,
    isSending,
    closeMenu,
    animateCloseMenu,
    toggleIsActive,
}: Props) => {
    const [showEmailInput, setShowEmailInput] = useState(false)
    const [emailAddress, setEmailAddress] = useState('')
    const [showFeedBack, setShowFeedBack] = useState(false)
    const [emailSent, setEmailSent] = useState(false)

    const { chat_bg_color, terms_link, menu_items, tenant_id } = dataset
    const { height } = mainSizing

    const termsAvailable = terms_link !== ''

    const resetBot = () => {
        restart()
        closeMenu()
    }

    const onEmailInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmailAddress(event.target.value.trim())
    }

    const sendTranscriptEmail = () => {
        if (!validateEmail(emailAddress)) {
            return
        }
        send('', emailAddress, { msg_type: 'transcript_request' })
        setShowEmailInput(false)
        setEmailSent(true)
        setEmailAddress('')
        setTimeout(() => {
            setEmailSent(false)
        }, 4000)
    }

    const validateEmail = (email: string) => {
        return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(email)
    }

    const handleCloseWidget = () => {
        restart()
        toggleIsActive()
    }

    const handleContentClick = (contentfulId: string) => {
        if (!isSending) {
            stopVideosPlaying()
            sessionStorage.getItem('username') ?? sessionStorage.setItem('username', defaultUserName)
            sessionStorage.getItem('initial') ?? sessionStorage.setItem('initial', defaultUserInitial)
            sessionStorage.getItem('capitalisedInitial') ?? sessionStorage.setItem('capitalisedInitial', defaultCapitalisedUserInitial)
            sessionStorage.getItem('relationship') ?? sessionStorage.setItem('relationship', defaultRelationship)
            send('', contentfulId)
            closeMenu()
        }
    }

    const closeFeedbackForm = () => {
        setShowFeedBack(false)
    }

    const createPoweredByLink = () => {
        if (!tenant_id) {
            // This is mainly for dev purposes
            console.error('Missing tenant_id in dataset. Please check admin panel settings and ensure these fields are complete.')
        }
        return `https://accesscharity.org.uk/?source_url=${window.location.href}&tenant_id=${tenant_id}`
    }

    return (
        <div className={animateCloseMenu ? 'widgetMenuOverlayfadeOut' : 'widgetMenuOverlay'}>
            <div
                className={animateCloseMenu ? 'widgetMenufadeOut' : 'widgetMenu'}
                style={{ backgroundColor: chat_bg_color }}
            >
                <div className='widgetMenuHeader'>
                    <div>{showFeedBack ? 'Feedback' : 'Menu'}</div>
                    <button
                        className='widgetMenuCloseBtn'
                        onClick={() => closeMenu()}
                    >
                        <UpChevronIcon
                            stroke='black'
                            role='close'
                        />
                    </button>
                </div>
                {showFeedBack ? (
                    <FeedbackForm
                        config={dataset}
                        closeFeedbackForm={closeFeedbackForm}
                        send={send}
                        mainSizing={mainSizing}
                        closeWidget={handleCloseWidget}
                    />
                ) : (
                    <>
                        <div
                            className='widgetMenuOptions'
                            style={{ maxHeight: `calc(${height} - 130px)` }}
                        >
                            <div
                                className='widgetMenuOpt'
                                onClick={() => resetBot()}
                            >
                                <img
                                    src={refresh}
                                    className='widgetMenuOptImg restart'
                                    alt='Restart chat'
                                    title='Restart Chat'
                                />
                                Restart the chat
                            </div>
                            <div
                                className='widgetMenuOpt'
                                onClick={() => setShowFeedBack(true)}
                            >
                                <FeedbackIcon className='widgetMenuOptImg' />
                                Give feedback
                            </div>
                            <div
                                className='widgetMenuOpt'
                                onClick={() => setShowEmailInput(!showEmailInput)}
                            >
                                <img
                                    src={email}
                                    className='widgetMenuOptImg'
                                    alt='Email transcript'
                                    title='Email'
                                />
                                Email transcript
                            </div>
                            {showEmailInput && (
                                <div className='widgetMenuEmailForm'>
                                    <input
                                        placeholder='Enter email address'
                                        value={emailAddress}
                                        onChange={onEmailInputChange}
                                    ></input>
                                    <button
                                        className='sendEmailBtn'
                                        type='button'
                                        onClick={sendTranscriptEmail}
                                    >
                                        <SendIcon stroke='black' />
                                    </button>
                                </div>
                            )}
                            {emailSent && <div className='widgetMenuEmailSent'>Transcript has been sent to the email address provided</div>}
                            {(menu_items || []).map((link: any, index: number) => {
                                return (
                                    <div
                                        key={index}
                                        className='widgetMenuOpt'
                                        onClick={() => {
                                            !isSending && handleContentClick(link.contentful_id)
                                        }}
                                        style={{ cursor: isSending ? 'wait' : 'pointer' }}
                                        title={isSending ? 'Please wait...' : link.title}
                                    >
                                        <ChatBubble className='widgetMenuOptImg' />
                                        {link.title}
                                    </div>
                                )
                            })}
                        </div>
                        <div className='widgetMenuFooter'>
                            {termsAvailable && (
                                <a
                                    href={terms_link}
                                    target={'_blank'}
                                    rel={'noopener noreferrer'}
                                >
                                    Terms & Privacy
                                </a>
                            )}
                            <div className='widgetMenuPB'>
                                <p>Powered by</p>
                                <a
                                    href={createPoweredByLink()}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                >
                                    <img
                                        loading='lazy'
                                        alt={'Powered by'}
                                        src={AvaIcon}
                                    />
                                </a>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}
